import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { useTranslation as g } from "react-i18next";
import { Box as n, Typography as c, List as y, ListItem as N, ListItemText as R, Divider as T } from "@mui/material";
import { makeStyles as u } from "tss-react/mui";
import { DEFAULT_CURRENCY as _ } from "@lumirental/lumi-web-shared/lib/constants/date/DEFAULT_CURRENCY";
import { useConfigContext as x } from "@lumirental/lumi-web-shared/lib/contexts/Config.context";
import C from "../../../../common/Button/Button.js";
import D from "../../../../common/Dialogs/Responsive/ResponsiveDialog.js";
import f from "./DropoffChargesDialog.style.js";
const E = u()(f), d = {
  INTRA_CITY: 0,
  INTRA_REGION: 50,
  INTER_REGION: 300
}, b = ({
  isOpen: m,
  onClose: s
}) => {
  const { classes: i } = E(), { t: r } = g(), { isMobile: l } = x(), o = [
    {
      id: 1,
      title: r("rental_policy_different_branch_point_1"),
      value: r("Free")
    },
    {
      id: 2,
      title: r("rental_policy_different_branch_point_3"),
      value: `${d.INTRA_REGION} ${_}`
    },
    {
      id: 3,
      title: r("rental_policy_different_branch_point_4"),
      value: `${d.INTER_REGION} ${_}`
    }
  ];
  return /* @__PURE__ */ e(
    D,
    {
      isMobile: l,
      open: m,
      onClose: s,
      dataTestid: "dropoffChargesInfoDialog",
      children: /* @__PURE__ */ a(n, { className: i.contentWrapper, children: [
        /* @__PURE__ */ a(n, { sx: { marginBottom: 3 }, children: [
          /* @__PURE__ */ e(
            c,
            {
              sx: { marginBottom: 1 },
              variant: "h2",
              className: i.title,
              children: r("modal_title_rental_poilcy_different_branch_drop_off")
            }
          ),
          /* @__PURE__ */ e(c, { variant: "body", className: i.desc, children: r("rental_policy_text_different_branch_drop_off") })
        ] }),
        /* @__PURE__ */ e(y, { sx: { padding: 0, marginBottom: 2 }, children: o.map((t, h) => {
          const p = h === o.length - 1;
          return /* @__PURE__ */ a(n, { children: [
            /* @__PURE__ */ e(N, { className: i.listItem, children: /* @__PURE__ */ e(
              R,
              {
                primary: t == null ? void 0 : t.title,
                secondary: t == null ? void 0 : t.value,
                classes: {
                  root: i.textListItem,
                  primary: i.primaryText,
                  secondary: i.secondaryText
                }
              }
            ) }),
            !p && /* @__PURE__ */ e(T, {})
          ] }, t == null ? void 0 : t.id);
        }) }),
        !l && /* @__PURE__ */ e(
          C,
          {
            fullWidth: !0,
            dataTestid: "acknowledgeDropoffCharges",
            onClick: s,
            children: r("modal_btn_acknowledged")
          }
        )
      ] })
    }
  );
}, S = b;
export {
  S as default
};
